<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 风险提示 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("logs.prompt_statement") }}</span>
          <div class="lie">
            <table>
              <tbody>
                 <!-- 是否启用 -->
                <tr>
                  <td>{{ $t("logs.disclaimer2") }}:</td>
                  <td>
                    <el-checkbox
                      v-model="riskhint_on"
                      style="padding-right:10px;margin:10px 0"
                    ></el-checkbox>
                  </td>
                </tr>
               
                 <!-- 保存归档，是否添加免责申明 -->
                <tr>
                  <td>{{ $t("logs.disclaimer4") }}:</td>
                  <td>
                    <el-checkbox
                      v-model="save_riskhint_while_arc"
                      style="padding-right:10px;margin:10px 0"
                    ></el-checkbox>
                  </td>
                </tr>
               
                 <!-- disclaimer_utf8_content -->
                <tr>
                  <td>{{ $t("logs.hint_new1") }}:</td>

                  <td style="width:70%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 18 }"
                      placeholder=""
                      v-model="riskhint_html_utf8_content"
                      clearable
                    >
                    </el-input>
                  </td>
                </tr>
                  <!-- riskhint_en_content -->
                <tr>
                  <td>{{ $t("logs.hint_new2") }}:</td>

                  <td style="width:70%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 18 }"
                      placeholder=""
                      v-model="riskhint_html_en_content"
                      clearable
                    >
                    </el-input>
                  </td>
                </tr>
                    <!-- riskhint_gbk_content -->
                <tr>
                  <td>{{ $t("logs.hint_new3") }}:</td>

                  <td style="width:70%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 18 }"
                      placeholder=""
                      v-model="riskhint_plain_utf8_content"
                      clearable
                    >
                    </el-input>
                  </td>
                </tr>
 <tr>
                  <td>{{ $t("logs.hint_new4") }}:</td>

                  <td style="width:70%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 18 }"
                      placeholder=""
                      v-model="riskhint_plain_en_content"
                      clearable
                    >
                    </el-input>
                  </td>
                </tr>
             
                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button type="primary"   :disabled="$root.jurisdiction.only_query == 0" @click="save_dis()"
                      >{{
                  $t("logs.save_a")
                }}</el-button
                    >
                  
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
          <!-- 个性化免责 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.disclaimer_daf1") }}</span>
                <div class="main maina-a">
                    <p>
                       <span class="main_text"> {{ $t("logs.prompt_statement_show") }}:</span>
              <el-select
                v-model="riskhint_default"
                placeholder="请选择"
                style="width: 150px"
              >
                <el-option
                  v-for="item in riskhint_default_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button
              style="margin-left:14px"
                @click="save_user_smtp()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.save_a") }}</el-button
              >
                        <!-- 增加发件人白名单 -->

                        <el-button @click="save4()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.disclaimer_daf1_add") }}</el-button>
                      
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table02">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_individuality" >
                            <!-- 序号 -->

                            <el-table-column prop="RECSEQ" :label="$t('table1.order')" width="120"> </el-table-column>
                            <!-- 域名或邮箱账号 -->

                            <el-table-column prop="EMAIL" :label="$t('table1.yuming')">
                            </el-table-column>
                              <!-- 风险提示是否开启 -->

                            <el-table-column prop="SHOW_ACTION" :label="$t('logs.prompt_statement_table')">
                            </el-table-column>
                            <!-- 操作 -->

                            <el-table-column prop="address" :label="$t('table1.operation')" width="120">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick4(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu4"  v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS_from' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS_from">
                <span style="padding:0 14px"></span>{{ $t("logs.disclaimer_daf1_add") }}
              </div>
              <p></p>
                        <div class="find">
                            <div class="find1">
                                <!-- 域名或邮箱账号 -->

                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("anti_gs1.doemailaddress") }} :
                                </div>
                                <div class="block block1" style="padding:10px;">
                                  <el-input
  type="textarea"
  style="width:100%"
  :autosize="{ minRows: 4, maxRows: 8}"
  placeholder="请输入内容"
  v-model="dnoremail">
</el-input>
                                   
                                </div>
                            </div>
                               <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 激活 -->

                    {{this.riskhint_active_text}}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="riskhint_active">
                      <el-radio :label="1">{{ $t("logs.Policy_comb12") }}</el-radio>
                      <el-radio :label="0">{{ $t("logs.Policy_comb13") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                            
                        </div>

             
                        <el-row>
                            <!-- 保存-->

                            <el-button type="primary" @click="save41()" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <!-- 取消-->

                            <el-button type="danger" @click="save42()">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu4"></div>
                    
           
        
           
        
                </div>
            </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      dnoremail:'',
     riskhint_default:'NO',
     riskhint_default_arr:[],
      save_riskhint_while_arc:false,
     riskhint_on:false,
riskhint_html_utf8_content:'',
riskhint_html_en_content:'',
riskhint_plain_utf8_content:'',
riskhint_plain_en_content:'',
   data_ok:'',
   tanchu4:false,
  riskhint_active:0,
  riskhint_active_text:'',
   
  fileList_individuality:[],
    };
  },
  mounted() {
    // 
  this.getFileList6()// 风险提示
  this.getFileList_individuality() //个性化
      // this.disclaimer_content="声明:本邮件及其附件含有公司商业信息本邮件及其附件含有公司商业信息，仅限于发给上面地址中列出的个人或群组，禁止任何人未经发件人许可以任何形式（包括但不限于全部或部分地泄露、复制、或散发）不当使用本邮件中的信息。如果您错收了本邮件，请立即电话或邮件通知发件人并删除本邮件！DISCLAIMER:This e-mail and its attachments contain confidential informaition,which is intended only for the person or entity whose address is listed above.Any use of the information contained here in any way(including,but not limited to,total or partial disclosure,reproduction,or dissemination)by persons other than the intended recipient is prohibited.If you receive this e-mail in error,please notify the sender by phone or email immediately and delete it!"
           
  },
  methods: {
     // 风险提示加载
    getFileList_individuality() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_person_riskhint",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);
            this.loading = false;

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            
            this.riskhint_active_text=res.data.ret.add_riskhint;
            this.riskhint_default=res.data.ret.riskhint_default;
            this.riskhint_default_arr=res.data.ret.q_riskhint_default;
            this.fileList_individuality=res.data.ret.datalist;

 
          
          }
        });
    },
    // 个性化默认保存
    save_user_smtp() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "save_dftchk_riskhint",
            sid: sid,
           riskhint_default: this.riskhint_default,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.getFileList_individuality();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 删除
      handleClick4(index, scope) {
            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = scope.EMAIL;

                    this.$axios
                        .get("/api/adm/cgi/aspam.cgi", {
                            params: {
                                __mode: "del_person_riskhint",
                                sid: sid,
                                email: dnoremail,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_individuality();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
     //个性化保存
        save41() {
          this.$save_hint_test();
          this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let dnoremail = this.dnoremail;
            let str = this.$qs.stringify({
                __mode: "save_person_riskhint",
                sid: sid,
                email: dnoremail,
                action:this.riskhint_active,
               
            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                     
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu4 = false;

                        this.loading = false;
                        this.getFileList_individuality();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
                
           
        },
        save4() {
            this.tanchu4 = true;
            this.dnoremail = '';
            this.riskhint_active =0;
        },
        save42() {
            this.tanchu4 = false;
        },
   clear_dis(){
       this.riskhint_content=''
   },
     // 风险提示加载
    getFileList6() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_new_riskhint",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.data_ok=res.data.ret.ok;
            



 this.riskhint_html_utf8_content=res.data.ret.result.riskhint_html_utf8_content;
 this.riskhint_html_en_content=res.data.ret.result.riskhint_html_en_content;
 this.riskhint_plain_utf8_content=res.data.ret.result.riskhint_plain_utf8_content;
 this.riskhint_plain_en_content=res.data.ret.result.riskhint_plain_en_content;
 this.riskhint_on=res.data.ret.result.riskhint_on==1?true:false
 this.save_riskhint_while_arc=res.data.ret.result.save_riskhint_while_arc==1?true:false

 
          
          }
        });
    },
    // 风险提示保存
    save_dis() {
      // this.loading = true;
this.$save_hint_test();
this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
     
      let str = this.$qs.stringify({
        __mode: "save_new_riskhint",
        sid: sid,
        



      save_riskhint_while_arc:this.save_riskhint_while_arc==true?1:0,
      riskhint_on:this.riskhint_on==true?1:0,
      riskhint_html_utf8_content:this.riskhint_html_utf8_content,
      riskhint_html_en_content:this.riskhint_html_en_content,
      riskhint_plain_utf8_content:this.riskhint_plain_utf8_content,
      riskhint_plain_en_content:this.riskhint_plain_en_content,
      data_loadok:this.data_ok,
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList6();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },


  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
.lie tbody td:nth-child(1) {
    width: 260px;
}
.tableurl {
  /deep/ .has-gutter th:nth-child(2) {
    text-align: left;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: left;
  }
}

/deep/ .has-gutter th {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(4) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(5) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(3) {
  text-align: left;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(4) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(5) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(3) {
  text-align: left;
}

.pop-up .el-checkbox:last-of-type {
  margin-right: 8px;
}

.ruel_find .find {
  width: 100%;
}

.ruel_find .block {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ruel_find_text {
  margin-right: 8px;
  color: #0e2c5e;
  width: 120px;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.ruel_find {
  /deep/ .el-button {
    padding: 8px 16px;
    // margin-left: 10px;
    font-size: 12px;
    // background: #eceff4;
    margin-top: 14px;
    margin-right: 10px;
  }

  .el-button--primary {
    background: #006be7;
  }

  .el-button--danger {
    background: #f05f5f;
  }
}

.pop-up {
  .find-text {
    margin-right: 8px;
  }
}

.policy_comb .pop-up {
  position: fixed;
  // padding: 20px 0;
  width: 40%;
  // height: 62%;
  top: 10%;
  left: 30%;
  z-index: 101;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  background: white;

  border-radius: 4px;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}
// .pop-up1{
//     height: 64%;
// }
/deep/ .table_hover tr td:nth-child(3) :hover {
  cursor: pointer;
}
.main_text {
  margin-right: 6px;

  color: #0e2c5e;
}
.maina-a {
  font-size: 14px;
      border: 2px solid #d2d7e6;
      padding: 5px 0 5px 14px;
  /deep/ .el-alert {
    line-height: 0px;
  }

  /deep/.el-alert__title {
    line-height: 14px;
  }
}
</style>
